import { Component,  OnInit } from '@angular/core';
import { StorageConstant } from '@shared/constants';
import { LocalStorageUtil } from '@shared/utils/local-storage.util';
import { AnnouncementApiService } from '@shared/services/announcement-api.service';
import { BaseComponent } from '@shared-features/components/base-component/base.component';
import { Announcement } from '@shared/models/announcement.model';

@Component({
  selector: 'app-announcement-bar',
  templateUrl: './announcement-bar.component.html',
  styleUrls: ['./announcement-bar.component.scss']
})
export class AnnouncementBarComponent extends BaseComponent implements OnInit {
  announcement:Announcement
  announcementLocalStorage:{showAnnouncementBar: boolean , id:number}

  constructor(
    private announcementApiService :AnnouncementApiService
  ) {
    super()
  }

  ngOnInit() {
    this.announcementLocalStorage = LocalStorageUtil.getItem(StorageConstant.ANNOUNCEMENT_BAR) || {}
    this.getAnnouncement()
  }

  hideAnnouncementBar(){
    this.announcementLocalStorage.showAnnouncementBar = false
    this.announcementLocalStorage.id = this.announcement.id
    LocalStorageUtil.setItem(StorageConstant.ANNOUNCEMENT_BAR,this.announcementLocalStorage)
  }

  getAnnouncement(){
    this.load(this.announcementApiService.getAnnouncement()).subscribe((announcement) => {
      this.announcement = announcement;
      if (announcement && announcement.id !== this.announcementLocalStorage?.id) {
        this.announcementLocalStorage.showAnnouncementBar = true;
        this.announcementLocalStorage.id = this.announcement.id;
        LocalStorageUtil.setItem(StorageConstant.ANNOUNCEMENT_BAR, this.announcementLocalStorage);
      }
    });
  }

  private isEmail(value: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  private isLink(value: string): boolean {
    return /^https?:\/\/\S+$/.test(value);
  }
}
